import { Translate } from 'i18n';
import { FC } from 'react';
import LinguNotification from 'students/views/shared/components/LinguNotification';
import styled from 'styled-components';

interface IProps {
  show: boolean;
  onClose: () => void;
}

// Non-accusatory notice shown when a student tries to paste into an answer field.
const PasteBlockedNotification: FC<IProps> = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <LinguNotification onClose={onClose}>
      <SMessage>
        <Translate
          str="frontend.member.assignments.paste_blocked_notice"
          params={{
            defaultValue:
              "Pasting text isn't allowed here. To keep your work your own, please type your answer manually."
          }}
        />
      </SMessage>
    </LinguNotification>
  );
};

export default PasteBlockedNotification;

const SMessage = styled.p`
  margin: 0;
  padding-inline-end: 16px;
`;
